import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLButtonElement> {
  static targets = ['challengeInput', 'confirmButton']

  static values = {
    challenge: String
  }

  declare readonly challengeInputTarget: HTMLInputElement
  declare readonly confirmButtonTarget: HTMLButtonElement
  declare readonly hasConfirmButtonTarget: boolean
  declare readonly hasChallengeInputTarget: boolean

  declare challengeValue: string
  declare disabledButtonClone: HTMLButtonElement

  #createClonedDisabledButton(): void {
    this.disabledButtonClone = document.createElement('button')
    this.disabledButtonClone.disabled = true
    this.disabledButtonClone.innerHTML = this.confirmButtonTarget.innerHTML
    this.disabledButtonClone.classList.add(...this.confirmButtonTarget.classList)
    this.confirmButtonTarget.classList.add('hidden')
    this.confirmButtonTarget.parentNode?.insertBefore(
      this.disabledButtonClone,
      this.confirmButtonTarget
    )
  }

  connect(): void {
    if (this.hasConfirmButtonTarget && this.confirmButtonTarget.tagName !== 'BUTTON') {
      this.#createClonedDisabledButton()
    }
    this.changeChallenge()
  }

  changeChallenge(): void {
    if (!this.hasChallengeInputTarget) return

    const isMatch = this.challengeInputTarget.value.toLowerCase() === this.challengeValue

    if (this.confirmButtonTarget.tagName === 'BUTTON') {
      this.confirmButtonTarget.disabled = !isMatch
    } else if (isMatch) {
      this.disabledButtonClone.classList.add('hidden')
      this.confirmButtonTarget.classList.remove('hidden')
    } else {
      this.disabledButtonClone.classList.remove('hidden')
      this.confirmButtonTarget.classList.add('hidden')
    }
  }
}
